import { CustomColumn } from '../../../../types/customColumn';

export const saleExportInvoiceColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'saleDetailId',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },

  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;

      return (
        <div className="text-sm leading-6">
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>

          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>

          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },

  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unit } = row.original;
      return (
        <div className="text-sm leading-6">
          {Number(quantity).toFixed(2)} {unit || ''}
        </div>
      );
    },
  },

  {
    Header: 'Precio Unitario',
    accessor: 'netUnitPrice',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value).toFixed(2)}</div>
    ),
  },

  {
    Header: 'Descuento',
    accessor: 'discount',
    customCell: ({ value }) =>
      value ? (
        <div className="text-red-600 text-sm leading-6">
          -${Number(value).toFixed(2)}
        </div>
      ) : (
        <div className="text-sm leading-6">$0.00</div>
      ),
  },

  {
    Header: 'Total Neto',
    accessor: 'netAmount',
    customCell: ({ row }) => {  
      const { netAmount } = row.original;
      return (
        <div className="text-sm font-medium leading-6">
          ${Number(netAmount).toFixed(2)}
        </div>
      );
    },
  },
];
